import { BaseError } from "./BaseError";
import type { ErrorContext } from "../types/index";
import { NOT_FOUND_ERROR_CODES } from "../constants/errorCodes";

export interface NotFoundErrorOptions {
  message: string;
  resource?: string;
  id?: string;
  context?: Partial<ErrorContext>;
  code?: string;
  cause?: Error;
}

/**
 * Error thrown when a resource is not found
 */
export class NotFoundError extends BaseError {
  public readonly resource?: string;
  public readonly id?: string;

  constructor(options: NotFoundErrorOptions) {
    super({
      message: options.message,
      category: "not_found",
      severity: "low",
      statusCode: 404,
      code: options.code ?? NOT_FOUND_ERROR_CODES.NOT_FOUND_ERROR,
      context: options.context,
      cause: options.cause,
      userVisible: true,
      reportable: false,
    });

    this.resource = options.resource;
    this.id = options.id;
  }
}
